import React from 'react'
import {useTranslation} from 'react-i18next'

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  Stack,
  Tooltip,
  tooltipClasses,
} from '@mui/material'

import {
  ACCOUNT_TYPE_CURRENT,
  ACCOUNT_TYPE_SAVINGS,
} from '@progyny/pages/Budget/Reimbursement/helpers/PaymentFormModel'

import {theme} from '@root/theme'

type AccountTypeRadioProps = {
  value: string
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
}

const AccountTypeRadio: React.FC<AccountTypeRadioProps> = ({
  value,
  onChange,
}) => {
  const {t} = useTranslation()

  return (
    <FormControl sx={{mt: 4}}>
      <Stack direction='row' alignItems='center' gap={'8px'}>
        <FormLabel id='account-type-label' sx={accountTypeLabelSx}>
          {t('profile_bank_details_account_type')}
        </FormLabel>
        <Tooltip
          arrow
          title={t('profile_bank_details_account_type_tooltip')}
          slotProps={{popper: {sx: tooltipPopperSx}}}
        >
          <InfoOutlinedIcon
            data-testid='account-type-info-icon'
            sx={accountTypeInfoIconSx}
          />
        </Tooltip>
      </Stack>
      <RadioGroup
        row
        aria-labelledby='account-type-label'
        name='accountType'
        value={value || ACCOUNT_TYPE_SAVINGS}
        onChange={onChange}
        sx={{mt: 1, gap: 4}}
      >
        <FormControlLabel
          value={ACCOUNT_TYPE_SAVINGS}
          control={<Radio disableRipple />}
          label={t('profile_bank_details_account_type_savings')}
        />
        <FormControlLabel
          value={ACCOUNT_TYPE_CURRENT}
          control={<Radio disableRipple />}
          label={t('profile_bank_details_account_type_current')}
        />
      </RadioGroup>
    </FormControl>
  )
}

export default AccountTypeRadio

const accountTypeLabelSx = {
  fontSize: 16,
  fontWeight: 600,
  color: 'inherit',
  '&.Mui-focused': {color: 'inherit'},
}

const accountTypeInfoIconSx = {
  color: theme.palette.other.brandColors.lightGray,
  fontSize: 18,
}

const tooltipPopperSx = {
  [`&.${tooltipClasses.popper}[data-popper-placement*="bottom"] .${tooltipClasses.tooltip}`]:
    {
      marginTop: '0px',
    },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: 'black',
    color: 'white',
    fontSize: 12,
    lineHeight: 1.4,
    padding: '16px 24px',
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: 'black',
  },
  width: 230,
}
